import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteAbout = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const hasMedia = true;

	const header = `Creatively Shine®`;
	const subHeader = `Where Your Child's Path to Success Begins`;
	const tagline = "Our Proprietary Reggio Emilia- Inspired Curriculum";
	const reverseOrder = false;
	const textAlign = "left"; // left / center / right
	const lineBreak = true;
	const content =
		"Our Reggio Emilia-inspired curriculum, Creatively Shine®, is based on the latest research and trends to prepare your children for their educational careers equipping them with cognitive, social, emotional, physical and language skills.";
	const image =
		"https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_webp,q_auto/content/trustedcare/trustedcare-a-teacher-helping-children-in-preschool.jpg";

	const video = false;
	const autoPlay = false;

	//const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}`;
	const youtubeEmbedUrl = `https://www.youtube.com/embed/L3gOf2XDp8Y`;

	const button = "Discover Reggio Emilia";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary";
	const buttonSecondaryLink = "/wesbite/about-us";

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							direction={hasMedia ? (reverseOrder ? "row-reverse" : "row") : {}}
						>
							{(tagline ||
								header ||
								subHeader ||
								lineBreak ||
								content ||
								button ||
								buttonSecondary) && (
								<Grid item xs={12} sm={12} md={hasMedia ? 6 : 12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										height={"100%"}
										m={
											hasMedia
												? reverseOrder
													? { xs: 0, sm: "0px 0px 0px 40px" }
													: { xs: 0, sm: "0px 40px 0px 0px" }
												: {}
										}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}

										{(button || buttonSecondary) && (
											<Box
												className={classes.columnButtonsBox}
												justifyContent={textAlign}
											>
												{button && (
													<Button
														size="large"
														color="primary"
														variant="contained"
														disableElevation
														href={buttonLink}
														className="columnButton"
													>
														{button}
													</Button>
												)}

												{buttonSecondary && (
													<Button
														size="large"
														color="secondary"
														variant="outlined"
														disableElevation
														href={buttonSecondaryLink}
														className="columnButton"
													>
														{buttonSecondary}
													</Button>
												)}
											</Box>
										)}
									</Box>
								</Grid>
							)}

							{hasMedia && (
								<Grid item xs={12} sm={12} md={6}>
									{video ? (
										<>
											<div
												className="video-responsive"
												style={{
													position: "relative",
													paddingBottom: "56.25%",
													height: 0,
												}}
											>
												<iframe
													style={{
														position: "absolute",
														top: 0,
														left: 0,
														width: "100%",
														height: "100%",
													}}
													src={
														autoPlay
															? `${youtubeEmbedUrl}?autoplay=1`
															: youtubeEmbedUrl
													}
													frameBorder="0"
													allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
													allowFullScreen
													title="Embedded YouTube Video"
												/>
											</div>
										</>
									) : (
										<Box
											width={"100%"}
											height={"100%"}
											display={"inline-block"}
										>
											<Avatar
												src={image}
												alt="pic"
												imgProps={{
													decoding: "async",
													loading: "lazy",
												}}
												className="picture"
											/>
										</Box>
									)}
								</Grid>
							)}
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteAbout;
